import {
  MY_ORDERS_LIST_ACTION_TYPE,
  EDIT_ORDER_ACTION_TYPE,
  INSERT_PROFORMA_INVOICE_ACTION_TYPE,
  BLOCKED_TILL_ACTION_TYPE,
  DELETE_MY_ORDER_ACTION_TYPE,
  ORDER_CANCEL_REASON_ACTION_TYPE,
  GET_FOLLOWUP_ACTION_TYPE,
  FOLLOW_UP_ACTION_TYPE,
  DOWNLOAD_PERFORMA_INVOICE,
  DOWNLOAD_NODUE_ACTION_TYPE,
  EVENT_CLOSURE_ACTION_TYPE,
  GENERATE_NODUE_ACTION_TYPE,
  ORDER_ADDITIONAL_SERVICE_IE_TYPE,
  UPDATE_EXIT_PASS_ACTION_TYPE,
  ORDER_ADDITIONAL_SERVICE_APPROVAL_ACTION_TYPE,
  ORDER_UPDATE_ADDITIONAL_HOUR,
  ORDER_UPDATE_ADDITIONAL_DISCOUNT,
  DOWNLOAD_TAX_INVOICE,
  ORDER_UPDATE_SECURITY_DEPOSIT,
  ORDER_UPDATE_EVENT_SERVICE,
  SEND_APPROVAL_PI_MAIL
} from "../../utils/constants";
const initialState = [];
function myOrdersReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case MY_ORDERS_LIST_ACTION_TYPE:
      return [...state, payload];
    case EDIT_ORDER_ACTION_TYPE:
      return [...state, payload];
    case DELETE_MY_ORDER_ACTION_TYPE:
      return [...state, payload];
    case ORDER_CANCEL_REASON_ACTION_TYPE:
      return [...state, payload];
    case BLOCKED_TILL_ACTION_TYPE:
      return [...state, payload];
    case GET_FOLLOWUP_ACTION_TYPE:
      return [...state, payload];
    case FOLLOW_UP_ACTION_TYPE:
      return [...state, payload];
    case INSERT_PROFORMA_INVOICE_ACTION_TYPE:
      return [...state, payload];
    case DOWNLOAD_PERFORMA_INVOICE:
      return [...state, payload];
    case DOWNLOAD_TAX_INVOICE:
      return [...state, payload];
    case GENERATE_NODUE_ACTION_TYPE:
      return [...state, payload];
    case DOWNLOAD_NODUE_ACTION_TYPE:
      return [...state, payload];
    case UPDATE_EXIT_PASS_ACTION_TYPE:
      return [...state, payload];
    case EVENT_CLOSURE_ACTION_TYPE:
      return [...state, payload];
    case ORDER_ADDITIONAL_SERVICE_IE_TYPE:
      return [...state, payload];
    case ORDER_ADDITIONAL_SERVICE_APPROVAL_ACTION_TYPE:
      return [...state, payload];
    case ORDER_UPDATE_ADDITIONAL_HOUR:
      return [...state, payload];
    case ORDER_UPDATE_ADDITIONAL_DISCOUNT:
      return [...state, payload];
    case ORDER_UPDATE_SECURITY_DEPOSIT:
      return [...state, payload];
    case ORDER_UPDATE_EVENT_SERVICE:
      return [...state, payload];
    case SEND_APPROVAL_PI_MAIL:
      return [...state, payload];
    default:
      return state;
  }
}
export default myOrdersReducer;
